module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("101 Things to Do with Beer")]), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Table of Contents")])]), _c('dl', [_c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01"
    }
  }, [_vm._v("Helpful Hints ")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02"
    }
  }, [_vm._v("Appetizers ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e144"
    }
  }, [_vm._v("Easy Beer Cheese Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e161"
    }
  }, [_vm._v("Beer-Battered Cauliflower ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e192"
    }
  }, [_vm._v("Golden Beer Cheese Puffs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e217"
    }
  }, [_vm._v("Crispy Beer Chicken Wings ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e250"
    }
  }, [_vm._v("Beer Candied Bacon ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e271"
    }
  }, [_vm._v("Garlic Parmesan Onion Rings ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e296"
    }
  }, [_vm._v("Light and Crispy Onion Shoestrings ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e319"
    }
  }, [_vm._v("Beer Barbecue Kielbasa Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e334"
    }
  }, [_vm._v("Ale Caramelized Onion and Bacon Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e363"
    }
  }, [_vm._v("Bacon-Wrapped Beer Brats ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e386"
    }
  }, [_vm._v("Beer-Battered Jalapeno Chips ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e415"
    }
  }, [_vm._v("Cerveza con Queso Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e440"
    }
  }, [_vm._v("Beer Cheese Crackers ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e459"
    }
  }, [_vm._v("Mini Corn Dogs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e494"
    }
  }, [_vm._v("Stout-Glazed Chicken Skewers ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breads ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e531",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Swiss Cheesy Beer Bread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e558",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer-Battered Apple Fritters ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e587",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Light-As-A-Feather Doughnut Holes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e616",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Beer Biscuits ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e635",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer, Bacon, and Cheddar Cornbread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e668",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caraway Beer Bread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e691",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soft Beer Pretzels ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e720",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer and Pimiento Cheese Muffins ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e741",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey-Wheat Beer Bread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e768",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Cornbread Waffles ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e797",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheese and Chive Beer Scones ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e830",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Focaccia Bread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e857",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("German Coffee Cake ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e894",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Best Glazed Banana Bread ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sauces and Condiments ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e935",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Barbecue Sauce ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e976",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Cheddar Sauce ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e993",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Best Beer Turkey Brine ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stout Mushroom Sauce ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Beer Mustard ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange Ale Salad Dressing ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Ale Ginger Chutney ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Butterscotch Sauce ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soups ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Best Beer Cheese Soup ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Crab Chowder ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer and Bacon Split Pea Soup ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French Apple and Brie Soup ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Texas Red Chili ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irish Red Potato Soup ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Wild Rice Soup ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slow Cooker Beer 'n' Bratwurst Cheddar Soup ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1379",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French Onion Soup ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Beef Stew ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1449",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bacon Cheeseburger Soup ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1480",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Navy Bean, Smoked Sausage, and Beer Soup ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dinners ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1513",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One-Pan Beer Onion Chicken ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1534",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Bacon Mac and Cheese ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1571",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer-Inated Grilled Pork Chops ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1600",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Cheese Fondue ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1625",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer-Simmered Sausage and Rice ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1656",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Barbecue Slow Cooker Ribs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1683",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Boiled Shrimp ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1708",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef and Stout Potpie ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1745",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken and Dumplings ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1782",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Welsh Rarebit ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1815",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer-Simmered Chicken Tacos ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1846",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crispy Beer Batter Fish Filets ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1877",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Extra Crispy Fried Chicken ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1908",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Can Chicken ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1935",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slow Cooker Beer French Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1956",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Glazed Corned Beef ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1973",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Beer Bratwurst ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1998",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Best Beef Brisket ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spaghetti with Beer-Braised Meatballs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Sweet Slow-Cooked Pulled Pork ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken and Mushroom Risotto ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey Mustard Roast Pork ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Italian Beef ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer-Braised Pot Roast ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer and Molasses Glazed BBQ Chicken ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Side Dishes ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bacon, Cheddar, and Beer Potatoes Au Gratin ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buttered Mushrooms with Thyme ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("German Potato Salad with Beer Dressing ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2329",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Cheddar and Beer Broccoli ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2350",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beans, Bacon, and Beer ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Corn with Chile Lime Butter ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2398",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("German Green Beans ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2425",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer-Braised Garlic Parmesan Acorn Squash ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2446",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Beer Hash Browns ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2479",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Refrigerator Pickles ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2504",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer-Glazed Carrots ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2523",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet and Sour Pale Ale ColeSlaw ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Desserts ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2556",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Stout Cake with Cream Cheese Frosting ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2589",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Cinnamon Beer Batter Crepes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2622",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cherry Beery Bundt Cake ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2653",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Gingerbread Cake ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2692",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Glazed Stout Brownies ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2723",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Stout Ice Cream ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2750",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irish Cheesecake ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2781",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Beer Cake ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2806",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer-Battered Caramel Bananas ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweets ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2843",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stout Almond Brittle ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2864",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Pretzel Truffles ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2881",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Stout Fudge ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2902",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Caramel Corn ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2933",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Sea Salt Caramels ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2956",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer-Glazed Peanuts ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metric Conversion Chart")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-493b3cdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bk01-toc.vue
// module id = 63
// module chunks = 0